import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'skills': [],
  'skillSelected': null,
  'loading': false,
};

export const wtsSkills = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_SKILLS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_SKILLS]: (state, action) => ({
      ...state,
      'loading': false,
      'skills': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_SKILLS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'skills': [],
    }),
    [ActionTypes.CHANGE_WTS_SKILL_SELECTED]: (state, action) => ({
      ...state,
      'loading': false,
      'skillSelected': action.payload,
    }),
  })(state, action);
};
